import { range } from 'lodash-es';
import { FC } from 'react';

import type { RecommendedResearchItem } from '../model';
import { RecommendedResearchGrid } from '../presentation/RecommendedResearch';
import { ResearchItemSkeleton } from './ResearchItemSkeleton';

export const RecommendedResearchSkeleton: FC<{ count: number }> = ({ count }) => {
  const data = range(count).map(id => ({ sourceId: `${id}` }) as RecommendedResearchItem);

  return <RecommendedResearchGrid data={data} render={() => <ResearchItemSkeleton hasAuthor hasLike hasViewCount />} />;
};

RecommendedResearchSkeleton.displayName = 'RecommendedResearchSkeleton';
